import { Link } from "react-router-dom";
import { useLiturgicalTheme } from "@/contexts/LiturgicalThemeContext";

export default function LiturgicalBanner() {
  const { season } = useLiturgicalTheme();

  return (
    <Link 
      to="/calendar"
      className="block text-center py-2 px-4 text-xs sm:text-sm font-['Nunito'] text-white hover:brightness-110 transition-all cursor-pointer overflow-hidden"
      style={{ backgroundColor: season.colors.primary }}
      data-testid="liturgical-banner"
    >
      <span className="opacity-90">Current Season: <strong>{season.name}</strong></span>
      <span className="mx-1 sm:mx-2 opacity-50">|</span>
      <span className="opacity-75 italic hidden sm:inline">{season.description}</span>
      <span className="opacity-75 italic sm:hidden">{season.description.split('.')[0]}</span>
      <span className="ml-1 sm:ml-2 opacity-60 text-xs">Learn more →</span>
    </Link>
  );
}
